import React, { useState, useEffect } from 'react';

import Loader from '../../Loader/Loader';
import { language } from '../Language';

export default function View(props) {

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

            setLoading(false);

    }, [props]);

    return (
        isloading ?
            <Loader />
        :
            <></>
    )
}